import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { ChevronIcon } from '@nebula/icons/ui';
import { useHistory } from 'react-router-dom';
import { trackPaymentAndBillingBannerClick } from '../../helpers/switch/analytics';

import {
  PaymentAndBillingBannerLayout,
  PaymentAndBillingBannerTitle,
  PaymentAndBillingBannerBody,
  PaymentAndBillingBannerButton,
} from './index.styles';

export const PaymentAndBillingBanner = () => {
  const history = useHistory();
  const theme = useContext(ThemeContext);

  const onBannerClickMethod = () => {
    trackPaymentAndBillingBannerClick();
    history.push('/billing');
  };

  return (
    <PaymentAndBillingBannerLayout>
      <PaymentAndBillingBannerTitle>Payment and billing</PaymentAndBillingBannerTitle>
      <PaymentAndBillingBannerBody>View your details and manage your payment method.</PaymentAndBillingBannerBody>
      {/* data-automation-test-element attribute is used for cypress testing in subscriptions automation so any change here should be updated accordingly */}
      <PaymentAndBillingBannerButton
        type="button"
        label="Go to Payment and billing"
        icon={<ChevronIcon direction="right" iconColor={theme.color.ui.blue[70]} iconSize="small" />}
        buttonKind="plainBlue"
        data-automation-test-element="banner-change-payment-method"
        onClick={onBannerClickMethod}
      />
    </PaymentAndBillingBannerLayout>
  );
};
